/**
 * CODESM SCRIPTS
 **/

const THEME_FOLDER = "../wp-content/themes/mercedes_childrens_clinic_v1";

function resetIntlTelInput()
{
	// utils are lazy loaded, so must check
	if (typeof intlTelInputUtils !== 'undefined')
	{
		var currentText = jQuery(this).intlTelInput("getNumber", intlTelInputUtils.numberFormat.E164);

		// sometimes the currentText is an object :)
		if (typeof currentText === 'string')
		{
			// will autoformat because of formatOnDisplay=true
			jQuery(this).intlTelInput('setNumber', currentText);
		}
	}
}

function addEvent(ele, event, func)
{
	if(ele.addEventListener) ele.addEventListener(event, link, false);
	else ele.attachEvent('on' + event, link);
}

function link(event)
{
	var target	= event.target;
	var url	= this.getAttribute('data-href');
	var newWindow = (this.getAttribute('data-newwindow') !== null) ? true : false;

	if (!target.href)
	{
		/*var newevent = document.createEvent("MouseEvents");
		
		if (newevent.initMouseEvent)
		{
			var newlink = document.createElement("a");
			newlink.setAttribute('href', url);
			newlink.innerHTML = 'link event';
			newevent.initMouseEvent(event.type, true, false, window, event.detail, event.screenX, event.screenY, event.clientX, event.clientY, event.ctrlKey, event.altKey, event.shiftKey, event.metaKey, event.button, null);
			newlink.dispatchEvent(newevent);
		}
		else
		{*/
			var meta = (newWindow) ? '_blank' : '_self';
			window.open(url, meta);
		/*}*/
	}
}

function setHrefs()
{
	if (document.querySelectorAll)
	{
		var datahrefs	= document.querySelectorAll('[data-href]'),
				dhcount	= datahrefs.length;
		
		while (dhcount-- > 0)
		{
			var ele = datahrefs[dhcount];
			addEvent(ele, 'click', link);
		}
	}
}

function formatDate(date)
{
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

jQuery(document).ready(function(){

	// HANDLE DATA-HREF
	setHrefs();

	// INTL-TEL-INPUT
	jQuery('.codesm-phone-field').intlTelInput({
		utilsScript: THEME_FOLDER + "/assets/scripts/utils.js",
		preferredCountries: ['US', 'MX'],
		nationalMode: false,
		initialCountry: "auto",
		geoIpLookup: function(callback) {
			jQuery.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
				var countryCode = (resp && resp.country) ? resp.country : "";
				callback(countryCode);
			});
		},
		formatOnDisplay: true
	});
	jQuery('.codesm-phone-field').on("keyup change", resetIntlTelInput);

	// FOUNDATION DATEPICKER
	jQuery('.codesm-datepicker-field').attr("readonly", "readonly");
	jQuery('.codesm-datepicker-field').fdatepicker();

	// SHOW POPUP 
	if (sessionStorage.getItem('importantAnnouncementPopupShown') !== 'true')
	{
		jQuery('#importantAnnouncementPopup').foundation('open');
		sessionStorage.setItem('importantAnnouncementPopupShown','true');
	}
});